var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 5.83398C17.2967 5.83398 5.33398 17.7967 5.33398 32.5007C5.33398 47.2047 17.2967 59.1673 32.0007 59.1673C46.7047 59.1673 58.6673 47.2047 58.6673 32.5007C58.6673 17.7967 46.7047 5.83398 32.0007 5.83398ZM32.0007 53.834C20.238 53.834 10.6673 44.2633 10.6673 32.5007C10.6673 20.738 20.238 11.1673 32.0007 11.1673C43.7633 11.1673 53.334 20.738 53.334 32.5007C53.334 44.2633 43.7633 53.834 32.0007 53.834Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14.2754V32.4994H50.224C50.224 22.3981 42.0987 14.2754 32 14.2754Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPieChart);
export default __webpack_public_path__ + "static/media/bx-pie-chart.d5ab41b7d5dc4f1077c5d13be6e3c8c0.svg";
export { ForwardRef as ReactComponent };